<style lang="less">
  @import '../styles/menu.less';
</style>

<template>
  <Menu ref="sideMenu" :active-name="$route.name" :open-names="openNames" :theme="menuTheme" width="auto" @on-select="changeMenu">
    <div v-for="(item,index) in menuList" :key="item.path">
      <MenuItem v-if="item.children.length<=1" :name="item.children[0].name">
      <!-- <Icon :type="item.icon" :size="iconSize"></Icon> -->
      <img :src="item.icon">
      <span class="layout-text">{{ itemTitle(item) }}</span>
      </MenuItem>

      <Submenu v-if="item.children.length > 1" :name="item.name">
        <template slot="title">
          <Icon :type="item.icon" :size="iconSize"></Icon>
          <span class="layout-text">{{ itemTitle(item) }}</span>
        </template>
        <div v-for="child in item.children" :key="child.name">
          <MenuItem :name="child.name">
          <Icon :type="child.icon" :size="iconSize"></Icon>
          <span class="layout-text">{{ child.title }}</span>
          </MenuItem>
        </div>
      </Submenu>
    </div>
  </Menu>
</template>

<script>
  export default {
    name: 'sidebarMenu',
    props: {
      menuList: Array,
      iconSize: Number,
      menuTheme: {
        type: String,
        default: 'dark'
      },
      openNames: {
        type: Array
      }
    },
    data() {
      return {
        course:'course'
      }
    },
    methods: {
      changeMenu(active) {
        this.$emit('on-change', active);
      },
      itemTitle(item) {
        if(typeof item.title === 'object') {
          return this.$t(item.title.i18n);
        } else {
          return item.title;
        }
      }
    },
    updated() {
      this.$nextTick(() => {
        if(this.$refs.sideMenu) {
          this.$refs.sideMenu.updateOpened();
        }
      });
    }

  };
</script>
<style lang="less" scoped>
  .ivu-menu-item {
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/sidebarMenu.vue